import React,{Component} from "react";
import {Modal,Button} from 'react-bootstrap';
//import errorlogo from "./images/error.png";
import "./header/Header.css";
import Cookies from "universal-cookie";
//import logo from "./images/BG.png";
//import {withRouter,Route} from "react-router-dom";
import "../scss/general.css";
const axios = require("axios");

const cookies=new Cookies();
//const pass = React.useRef;

//const axios = require("axios");
export default class ModalPWD extends Component {
        constructor(props) {
            super(props);
            this.state = { input:{},Npassword:"",Cpassword:"", errors: {password:"",cmpassword:""}, error:'',errorcss:"text-danger",heading:props.heading,
            isLoaded: false,isOpen:true,buttondisabled:false};
          }
          openModal=(e)=>{this.setState({ isOpen: true });}
          closeModal=(e)=>{this.setState({ isOpen: false });}
                
          componentDidMount()
          {
              if( cookies.get('LoginID'))
              {   
                let input=this.state.input;
                input['emp_id']=cookies.get('LoginID');                    
                this.setState({input});
              } 
          }
          handleNew=(event)=> {
            let input = this.state.input;
            input["PWD"] = event.target.value;
             // this.setState({input});
             this.setState({input,Npassword:event.target.value});
          }
          handleConfirm=(event)=> {
            this.setState({Cpassword:event.target.value});
          }
          handleSubmit=(event)=>{
            event.preventDefault();
            let isValid = true;
            if(this.validate())
            {
              this.setState({buttondisabled:true}); 
//              console.log(this.state.input);
              document.body.style.cursor="wait";

              axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/ChangePWD/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
                })  
                .then((res) => {
                  document.body.style.cursor="default";
                  console.log(res.data);
                  if(res.data === "1")
                  {
                    this.setState({errorcss:"div-change",error:"Password has been successfully changed.",buttondisabled:false,Npassword:"",Cpassword:""});
                    window.location.href = config.Appdir+'/login/';

                    //cookies.set('LoginID', this.state.emp, { path: '/' });
                  }
                  else
                  {   
                    this.setState({error:"Unable to reset password, try later.",errorcss:"text-danger",buttondisabled:false});
                  }
              })
              .catch=()=> {
                document.body.style.cursor="default";
                this.setState({error:"Unable to reset password, try later",errorcss:"text-danger",buttondisabled:false});
                  //console.log(error);
              }; 
            }          

            return isValid;
          }
          validate(){
    /*            let input = this.state.input;*/
            let errors = {};
            let isValid = true;
                /*Password Validation*/
            if (!this.state.Npassword) {
              isValid = false;
              errors["password"] = "Please enter password.";
            }
            if (!this.state.Cpassword) {
              isValid = false;
              errors["cmpassword"] = "Please enter password.";
            }
            if (this.state.Cpassword !== this.state.Npassword)  {
              isValid = false;
              errors["cmpassword"]= "Password doesn't match.";
            }
              this.setState({
                errors: errors
              });
              return isValid;
            }        
    render(){
        return(
        <React.Fragment>
        <Modal dialogClassName="border-radius-2" show={this.state.isOpen} onHide={this.closeModal}  border-radius="15px" transition="all .3s" backdrop="static"  aria-labelledby="contained-modal-title-vcenter" animation={true} centered >
        <Modal.Header closeButton style={{backgroundColor:"white", color:"black", height:"55px", paddingTop:4}}>
        <Modal.Title style={{ paddingTop:3}}>Change Password {this.props.Title}</Modal.Title>
        </Modal.Header> 
        <Modal.Body style={{ height:"175px", textAlign:"left",marginLeft:"20px", marginRight:"20px",marginTop:"8px"}}>
        <form className="form-horizontal">
            <div className="form-group row">
                <label >Enter New Password</label>
                <input type="password" className="form-control" placeholder="New Password" name="password" value={this.state.Npassword} onChange={this.handleNew} ></input>
                {/*<div className="text-danger">{this.state.errors.password}</div></div>*/}
                <small id="passwordHelp" className="text-danger">
                {this.state.errors.password}
                </small>      
            </div>
            <div className="form-group row">
                <label >Confirm Password</label>
                <input type="password" className="form-control" placeholder="Confirm Password" name="Cpassword" value={this.state.Cpassword} onChange={this.handleConfirm} ></input>
                {/*<div className="text-danger">{this.state.errors.password}</div></div>*/}
                <small id="passwordHelp" className="text-danger">
                {this.state.errors.cmpassword}
                </small>      
            </div>
            </form>
            <span className={this.state.errorcss}>{this.state.error}</span>
                        
            </Modal.Body>
          <br></br>
          <span style={{marginLeft:"23px",color:"black"}}> You will be logged off after resetting password.</span>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleSubmit} disabled={this.state.buttondisabled}>Save</Button>
            <Button variant="secondary" onClick={this.closeModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
        );
      }
  }      